import { useState } from "react";
import { hotTopics } from "@/mocks/chiagua";

const tabs = [
  { key: "all", label: "全部" },
  { key: "爆", label: "爆瓜" },
  { key: "热", label: "热门" },
  { key: "新", label: "新瓜" },
];

function tagColor(tag: string) {
  if (tag === "爆") return "bg-primary-500 text-background-50";
  if (tag === "热") return "bg-accent-500 text-background-50";
  return "bg-secondary-100 text-secondary-800";
}

export default function HotBoard() {
  const [tab, setTab] = useState("all");
  const list = tab === "all" ? hotTopics : hotTopics.filter((t) => t.tag === tab);

  return (
    <section id="hot" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">Hot Board</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日吃瓜热榜</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              按讨论热度实时滚动，榜单越靠前说明越多人正在吃这口瓜，点进评论区还能接着聊。
            </p>
          </div>

          <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={
                  "cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors " +
                  (tab === t.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100")
                }
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <ul className="divide-y divide-background-100">
            {list.map((t, idx) => (
              <li
                key={t.rank}
                className="flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-100/60 md:px-6"
              >
                <span
                  className={
                    "w-7 shrink-0 text-center font-heading text-xl font-black " +
                    (idx < 3 ? "text-primary-500" : "text-foreground-300")
                  }
                >
                  {t.rank}
                </span>
                <span className={"shrink-0 whitespace-nowrap rounded px-1.5 py-0.5 text-xs font-bold " + tagColor(t.tag)}>
                  {t.tag}
                </span>
                <a href="#discuss" className="min-w-0 flex-1 cursor-pointer">
                  <p className="truncate text-sm font-semibold text-foreground-900 md:text-[15px]">{t.title}</p>
                  <p className="mt-0.5 text-xs text-foreground-500 md:hidden">
                    热度 {t.heat} · 回复 {t.replies}
                  </p>
                </a>
                <span className="hidden shrink-0 whitespace-nowrap rounded-md bg-secondary-50 px-2 py-1 text-xs text-secondary-800 sm:inline">
                  {t.cat}
                </span>
                <div className="hidden shrink-0 items-center gap-4 text-xs text-foreground-500 sm:flex">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {t.heat}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {t.replies}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}